import React from 'react'

import { color, MiscUtils, useParamLink } from '@my/util'
import { ActiveButton, SimpleText, SizableText, XStack, YStack, XPReactNative, TZACardStyle, ScrollView } from '@my/ui'

const { FlatList } = XPReactNative;

import { userProfiles } from './helper'
import { FinancialReviewHeading, HomeMainHeading } from '../../components/index'
import { ProfileComponent } from '../../components/common/ProfileDetail'
import assets from '../../assets/images'
import { Platform } from 'react-native';
import { Info } from '@tamagui/lucide-icons-2';

// ProfileItem Component
const ProfileItem: React.FC<ProfileItemProps> = ({ profile }) => (
  <YStack
    //unstyled
    elevation={2}
    style={{
      ...TZACardStyle,
      justifyContent: "space-between",
    }}
    //bg={color.white}
    p="$4"
    my="$2"
    mx="$3"
    gap={10}
    //{...useParamLink('advisorDetails', { id: profile.id })}
  >
    <ProfileComponent name={profile.name} image={profile.image} />
    {/* Profile Description */}
    <XStack alignItems="center" justifyContent="space-between">
      <SizableText fontSize={15} color={color.black} lineHeight={17}>
        {profile.about || 'No description available'}
      </SizableText>
    </XStack>
    {/* Connect Button */}
    <ActiveButton
      onPress={() => MiscUtils.dialog.alert("Coming Soon! Stay tuned.")}
      style={{maxWidth: 140}}
      ButtonTextProps={{children: 'Connect'}}
    />
  </YStack>
)

// AdvisorMatch Component
export const AdvisorMatch: React.FC = () => {
  const output = (
    <YStack f={1} p="$4" bg="#fff" gap={10}>
      {/* Header - Display only on web */}
      {/* <HomeMainHeading
        displayNative
        onPress={() => {}}
        type="Advisor Match"
        image={assets.advisor1}
        footerImage={assets.filterIcon}
      /> */}
      <FinancialReviewHeading
        title="Advisor Match"
        img={assets.advisor}
      />
      <NoticeSection />
      {/* List of Advisor Profiles */}
      <YStack>
        {userProfiles.map((obj, idx) => <ProfileItem key={idx} profile={obj} />)}
      </YStack>
      {/* <FlatList
        data={userProfiles}
        renderItem={({ item }) => <ProfileItem profile={item} />}
        keyExtractor={(item) => item.id.toString()}
      /> */}
    </YStack>
  );
  
  return (
    Platform.OS === 'web' ? (
      output
    ) : (
      <ScrollView backgroundColor={color.white}>
        {output}
      </ScrollView>
    )
  );

}

const NoticeSection = () => (
  <XStack gap={10} backgroundColor={'rgb(243, 245, 247)'} padding={'$4'} borderRadius={10} borderWidth={1} borderColor={'rgba(220, 224, 229, 0.6)'}>
    <XStack mb={'$2'}>
      <Info width={20} height={20} />
    </XStack>
    <YStack>
      <XStack mb={'$2'}>
        <SimpleText fontWeight={'700'} fontSize={14} color={'rgb(102, 102, 102)'}>
          🚧 Under Construction 🚧
        </SimpleText>
      </XStack>
      <SimpleText fontSize={14} color={'rgb(102, 102, 102)'}>
        Advisor Match is coming soon. Stay tuned for this and many more updates!
      </SimpleText>
    </YStack>
  </XStack>
  
)
